import React from 'react';
import PropTypes from 'prop-types';

function Tooltip(props) {
  const { tooltipModel, canvasRef, image } = props;
  if (!tooltipModel || !canvasRef.current) return null;
  const position = canvasRef.current.getBoundingClientRect();
  const dataPoint = tooltipModel.dataPoints[0];
  const counts = tooltipModel.chart.data.datasets[1].data;

  return (
    <div
      className="engage-results-multi-select-tooltip tooltip-wrapper"
      style={{
        opacity: tooltipModel.opacity,
        left: `${position.left + window.scrollX + tooltipModel.caretX}px`,
        top: `${position.top + window.scrollY + tooltipModel.caretY}px`,
      }}
    >
      {image && (
        <img className="engage-results-multi-select-tooltip__image" src={image} alt="img" />
      )}
      <div className="engage-results-multi-select-tooltip__title">{dataPoint.label}</div>
      <div className="engage-results-multi-select-tooltip__body">
        <div className="engage-results-multi-select-tooltip__data-points">
          <div className="engage-results-multi-select-tooltip__data-point">
            <div>{dataPoint.dataset.label}</div>
            <div>{dataPoint.formattedValue}%</div>
          </div>
          <div className="engage-results-multi-select-tooltip__data-point">
            <div>Count</div>
            <div>{counts[dataPoint.dataIndex]}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  tooltipModel: PropTypes.shape({
    opacity: PropTypes.number,
    caretX: PropTypes.number,
    caretY: PropTypes.number,
    dataPoints: PropTypes.arrayOf(
      PropTypes.shape({
        datasetIndex: PropTypes.number,
        dataIndex: PropTypes.number,
        dataset: PropTypes.shape({
          label: PropTypes.string,
        }),
        formattedValue: PropTypes.string,
        label: PropTypes.string,
      })
    ),
    chart: PropTypes.shape({
      data: PropTypes.shape({
        datasets: PropTypes.arrayOf(PropTypes.shape({ data: PropTypes.arrayOf(PropTypes.number) })),
      }),
    }),
  }),
  canvasRef: PropTypes.shape({
    current: PropTypes.shape({
      getBoundingClientRect: PropTypes.func,
    }),
  }),
  image: PropTypes.string,
};

Tooltip.defaultProps = {
  tooltipModel: null,
  canvasRef: null,
  image: null,
};

export default Tooltip;
